var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.history") } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage" },
          [
            _c(
              "b-row",
              [
                _c("b-col", [
                  _c(
                    "div",
                    { staticClass: "requestsList" },
                    [
                      _c(
                        "f7-list",
                        { staticClass: "mb-2" },
                        [
                          _c(
                            "f7-list-item",
                            { class: _vm.additionalClass },
                            [
                              _c(
                                "b-row",
                                {
                                  staticClass:
                                    "no-gutter justify-content-start",
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "btnFilter_2 mr-2",
                                          on: {
                                            click: function ($event) {
                                              return _vm.refreshInbox()
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa-light fa-rotate-right",
                                          }),
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(_vm.$t("common.rfrsh")) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "btnFilter_2 form-group mx-3",
                                          on: {
                                            click: function ($event) {
                                              return _vm.extractCSV()
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa-light fa-upload fs-14px",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "fab-label" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("common.extract_list")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "f7-list-item",
                            {
                              staticClass:
                                "filter-item-section showLargeScreenOnly",
                            },
                            [
                              _c(
                                "b-row",
                                { staticClass: "min-w-100" },
                                [
                                  _vm.canSeeNormList
                                    ? _c(
                                        "b-row",
                                        { staticClass: "min-w-100" },
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "filter-item col-3 mb-3 text-truncate",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "filter-item-title text-ellipsis",
                                                      attrs: {
                                                        title: _vm.$t(
                                                          "filter.standard_title"
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "filter.standard_title"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "filter-item-content d-flex pt-2",
                                                    },
                                                    [
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value: _vm.normId,
                                                              expression:
                                                                "normId",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "z-2 position-relative cursor fs-14px-important h-100 mw-none select-appearance",
                                                          class: {
                                                            "text-muted":
                                                              !_vm.normId,
                                                          },
                                                          attrs: {
                                                            id: "norm-select",
                                                          },
                                                          on: {
                                                            change: [
                                                              function (
                                                                $event
                                                              ) {
                                                                var $$selectedVal =
                                                                  Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function (
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function (
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                _vm.normId =
                                                                  $event.target
                                                                    .multiple
                                                                    ? $$selectedVal
                                                                    : $$selectedVal[0]
                                                              },
                                                              _vm.delayApplyFilter,
                                                            ],
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "option",
                                                            {
                                                              staticClass:
                                                                "text-muted",
                                                              attrs: {
                                                                value: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "filter.selected_standard_none"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm._l(
                                                            _vm.normList,
                                                            function (norm) {
                                                              return _c(
                                                                "option",
                                                                {
                                                                  domProps: {
                                                                    value:
                                                                      norm.id,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      norm.label
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { staticClass: "d-flex flex-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "filter-item" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "filter-item-title text-ellipsis",
                                              attrs: {
                                                title: _vm.$t(
                                                  "common.date_start_label"
                                                ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "common.date_start_label"
                                                    )
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("datetime-picker-custom", {
                                            staticClass: "z-1",
                                            class: {
                                              "filter-item-input": true,
                                              "filter-item-input-complete":
                                                _vm.dateBegin,
                                              "error-datepicker":
                                                _vm.dateBeginError,
                                            },
                                            attrs: {
                                              format: "DD/MM/YYYY H:i:s",
                                              customInputParentClass:
                                                "filter-item-content",
                                              maxLength: 19,
                                              placeholderValue: _vm.$t(
                                                "common.datetime_picker_empty_date"
                                              ),
                                              inputIcon: "fa-solid fa-calendar",
                                            },
                                            on: { input: _vm.delayApplyFilter },
                                            model: {
                                              value: _vm.dateBegin,
                                              callback: function ($$v) {
                                                _vm.dateBegin = $$v
                                              },
                                              expression: "dateBegin",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _vm.dateBeginError
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "errors.Data_format_invalid"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "filter-item" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "filter-item-title text-ellipsis",
                                              attrs: {
                                                title: _vm.$t(
                                                  "common.date_end_label"
                                                ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "common.date_end_label"
                                                    )
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("datetime-picker-custom", {
                                            staticClass: "z-1",
                                            class: {
                                              "filter-item-input": true,
                                              "filter-item-input-complete":
                                                _vm.dateEnd,
                                              "error-datepicker":
                                                _vm.dateEndError,
                                            },
                                            attrs: {
                                              format: "DD/MM/YYYY H:i:s",
                                              customInputParentClass:
                                                "filter-item-content",
                                              customInputClass: "w-100",
                                              maxLength: 19,
                                              placeholderValue: _vm.$t(
                                                "common.datetime_picker_empty_date"
                                              ),
                                              inputIcon: "fa-solid fa-calendar",
                                            },
                                            on: { input: _vm.delayApplyFilter },
                                            model: {
                                              value: _vm.dateEnd,
                                              callback: function ($$v) {
                                                _vm.dateEnd = $$v
                                              },
                                              expression: "dateEnd",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _vm.dateEndError
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "errors.Data_format_invalid"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "filter-item" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "filter-item-title text-ellipsis",
                                              attrs: {
                                                title:
                                                  _vm.$t("common.action_type"),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t("common.action_type")
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "filter-item-content d-flex justify-content-between p-1 pt-2",
                                              attrs: {
                                                id:
                                                  "action-type-picker-link-" +
                                                  _vm.randomString,
                                                href: "#",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    "fixed-span-size " +
                                                    (_vm.actionTypeDisplay.nb >
                                                    0
                                                      ? "filter-item-input-complete"
                                                      : ""),
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.actionTypeDisplay
                                                        .label
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass:
                                                  "fa-light fa-chevron-down",
                                                attrs: {
                                                  size: "17px",
                                                  id: "action-type-chevron",
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-popover",
                                            {
                                              attrs: {
                                                target:
                                                  "action-type-picker-link-" +
                                                  _vm.randomString,
                                                title: _vm.$t(
                                                  "filter.selected_type_none"
                                                ),
                                                triggers: "focus",
                                                placement: "bottom",
                                              },
                                            },
                                            [
                                              _c("div", [
                                                _c(
                                                  "span",
                                                  { key: "allActionTypes" },
                                                  [
                                                    _c(
                                                      "b-form-checkbox",
                                                      {
                                                        attrs: {
                                                          value: true,
                                                          "unchecked-value": false,
                                                        },
                                                        on: {
                                                          change: _vm.checkAll,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.allActionType,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.allActionType =
                                                              $$v
                                                          },
                                                          expression:
                                                            "allActionType",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "font-weight-normal fs-13px",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.allActionType
                                                                  ? _vm.$t(
                                                                      "filter.all_uncheck"
                                                                    )
                                                                  : _vm.$t(
                                                                      "filter.all_check"
                                                                    )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("hr", {
                                                staticClass: "my-2 mx-m08",
                                              }),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.actionTypeCategories,
                                                function (
                                                  categoryStatus,
                                                  categoryName
                                                ) {
                                                  return _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "MoneyRoadcolorBlack",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "history.action_type_categories." +
                                                                  categoryName
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        _vm.actionTypeList,
                                                        function (
                                                          actionType,
                                                          index
                                                        ) {
                                                          return _c(
                                                            "span",
                                                            {
                                                              key:
                                                                actionType.id +
                                                                "-" +
                                                                index,
                                                            },
                                                            [
                                                              categoryStatus.includes(
                                                                actionType.id
                                                              )
                                                                ? _c(
                                                                    "b-form-checkbox",
                                                                    {
                                                                      attrs: {
                                                                        value: 1,
                                                                        "unchecked-value": 0,
                                                                      },
                                                                      on: {
                                                                        input:
                                                                          _vm.actionTypeChange,
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          actionType.state,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              actionType,
                                                                              "state",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "actionType.state",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "font-weight-normal fs-13px",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              actionType.label
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "filter-item" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "filter-item-title",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("administration.login")
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "filter-item-content",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.login,
                                                    expression: "login",
                                                  },
                                                ],
                                                class: {
                                                  "filter-item-input": true,
                                                  "filter-item-input-complete":
                                                    _vm.login,
                                                },
                                                attrs: {
                                                  type: "text",
                                                  placeholder: _vm.$t(
                                                    "administration.login"
                                                  ),
                                                },
                                                domProps: { value: _vm.login },
                                                on: {
                                                  input: [
                                                    function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.login =
                                                        $event.target.value
                                                    },
                                                    _vm.delayApplyFilter,
                                                  ],
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "filter-item" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "filter-item-title",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("common.user"))
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "filter-item-content",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.user,
                                                    expression: "user",
                                                  },
                                                ],
                                                class: {
                                                  "filter-item-input": true,
                                                  "filter-item-input-complete":
                                                    _vm.user,
                                                },
                                                attrs: {
                                                  type: "text",
                                                  placeholder:
                                                    _vm.$t("common.user"),
                                                },
                                                domProps: { value: _vm.user },
                                                on: {
                                                  input: [
                                                    function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.user =
                                                        $event.target.value
                                                    },
                                                    _vm.delayApplyFilter,
                                                  ],
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "d-flex mt-4",
                                      attrs: { cols: "3" },
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "btn mr-2",
                                          attrs: {
                                            size: "sm",
                                            disabled: !_vm.hasInputFilter,
                                          },
                                          on: { click: _vm.clearFilterFields },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t("filter.clr_fltr_field")
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "btn",
                                          attrs: { size: "sm" },
                                          on: { click: _vm.applyFilter },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(_vm.$t("filter.fltr")) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.activateSpinner
                        ? _c("spinner")
                        : _c(
                            "div",
                            [
                              _vm.inboxMessages.length
                                ? _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "common.results_actions_desc"
                                          ) +
                                            _vm.paginationObject.nbResultsTotal
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.inboxMessages.length
                                ? _c("b-table", {
                                    key: _vm.resetHisto,
                                    staticClass:
                                      "table mt-3 text-center table-striped",
                                    attrs: {
                                      hover: "",
                                      borderless: "",
                                      outlined: "",
                                      items: _vm.inboxMessages,
                                      fields: _vm.historyFields,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "cell(dateAction)",
                                          fn: function (data) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "cursor text-ellipsis",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      attrs: {
                                                        title: data.value,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatDateTime"
                                                          )(data.value)
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(name)",
                                          fn: function (data) {
                                            return [
                                              !data.value
                                                ? _c("div", [_vm._v("-")])
                                                : _c("div", [
                                                    _vm._v(_vm._s(data.value)),
                                                  ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(label)",
                                          fn: function (data) {
                                            return [
                                              !_vm.translateDetails(
                                                data.item.details,
                                                data.item
                                              ).length
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.addActionCategory(
                                                          data.item
                                                        )
                                                      ) + _vm._s(data.value)
                                                    ),
                                                  ])
                                                : _c(
                                                    "f7-accordion-item",
                                                    {
                                                      staticClass:
                                                        "accordionForm",
                                                      attrs: {
                                                        expanded:
                                                          data.item.open,
                                                      },
                                                      on: {
                                                        "accordion:open":
                                                          function ($event) {
                                                            data.item.open = true
                                                          },
                                                        "accordion:opened":
                                                          function ($event) {
                                                            data.item.openFinished = true
                                                            _vm.resetHisto =
                                                              !_vm.resetHisto
                                                          },
                                                        "accordion:close":
                                                          function ($event) {
                                                            data.item.open =
                                                              data.item.open = false
                                                          },
                                                        "accordion:closed":
                                                          function ($event) {
                                                            data.item.openFinished = false
                                                            _vm.resetHisto =
                                                              !_vm.resetHisto
                                                          },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "f7-accordion-toggle",
                                                        {
                                                          staticClass:
                                                            "accordionToggle",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-group row justify-content-center",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-sm-auto",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                          " +
                                                                      _vm._s(
                                                                        _vm.addActionCategory(
                                                                          data.item
                                                                        )
                                                                      ) +
                                                                      _vm._s(
                                                                        data.value
                                                                      ) +
                                                                      "\n                          "
                                                                  ),
                                                                  data.item
                                                                    .open ===
                                                                  true
                                                                    ? _c("i", {
                                                                        staticClass:
                                                                          "ml-1 mt-1 fa-light fa-chevron-down color-var-actionButtonColorBlue",
                                                                      })
                                                                    : _c("i", {
                                                                        staticClass:
                                                                          "ml-1 fa-light fa-chevron-right color-var-actionButtonColorBlue",
                                                                      }),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "f7-accordion-content",
                                                        {
                                                          class: {
                                                            accordionContentExpended:
                                                              data.item
                                                                .openFinished,
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.translateDetails(
                                                            data.item.details,
                                                            data.item
                                                          ),
                                                          function (
                                                            detail,
                                                            index
                                                          ) {
                                                            return _c("div", [
                                                              _vm.isRTPAction(
                                                                data.item
                                                              )
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "cursor",
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.detailsRTP(
                                                                              data.item
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c("u", [
                                                                        _vm._v(
                                                                          "\n                          " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "history.rtp_details"
                                                                              )
                                                                            )
                                                                        ),
                                                                      ]),
                                                                    ]
                                                                  )
                                                                : _vm.isAPICall(
                                                                    data.item
                                                                  )
                                                                ? _c(
                                                                    "span",
                                                                    [
                                                                      data.item
                                                                        .spinner
                                                                        ? _c(
                                                                            "spinner"
                                                                          )
                                                                        : detail.name ===
                                                                          "Response"
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _c(
                                                                                "b",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      detail.name
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "common.see_json"
                                                                                    )
                                                                                  )
                                                                              ),
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "fa fa-eye cursor px-2 color-var-actionButtonColorBlue",
                                                                                  on: {
                                                                                    click:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.seeXml(
                                                                                          detail.value
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                }
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : detail.name ===
                                                                          "MoreId"
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "cursor",
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.getAPIDetails(
                                                                                      data.item
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "history.click_more_info_api"
                                                                                  )
                                                                                )
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "span",
                                                                            [
                                                                              _c(
                                                                                "b",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      detail.name
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    detail.value
                                                                                  )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _c("span", [
                                                                    _c("span", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.translateDetailsPrint(
                                                                              data
                                                                                .item
                                                                                .typeAction,
                                                                              "name",
                                                                              detail
                                                                            )
                                                                          ) +
                                                                            " "
                                                                        ),
                                                                      ]),
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    detail.old
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                detail.old
                                                                              ) +
                                                                                " "
                                                                            ),
                                                                            _c(
                                                                              "b",
                                                                              [
                                                                                _vm._v(
                                                                                  "→"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    [
                                                                      "dateBegin",
                                                                      "dateEnd",
                                                                    ].includes(
                                                                      detail.name
                                                                    )
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm._f(
                                                                                  "formatDateTime"
                                                                                )(
                                                                                  detail.value
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.translateDetailsPrint(
                                                                                  data
                                                                                    .item
                                                                                    .typeAction,
                                                                                  "value",
                                                                                  detail
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                  ]),
                                                            ])
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1852455872
                                    ),
                                  })
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-center mt-5",
                                    },
                                    [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(_vm.$t("common.no_result"))
                                        ),
                                      ]),
                                    ]
                                  ),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.activateSpinner
              ? _c(
                  "b-row",
                  { staticClass: "mt-1" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c("cm-pagination", {
                          attrs: {
                            maxResultsByPage: _vm.paginationObject.maxResults,
                            firstIndex: _vm.paginationObject.firstIndex,
                            nbResultsTotal: _vm.paginationObject.nbResultsTotal,
                            refreshEvent: _vm.paginationObject.refresh,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }